import React, { useState } from 'react';
import { sendSmsVerification, verifySmsCode } from '../api';

function SmsTestPanel({ user }) {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [step, setStep] = useState('phone');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const handleSendSms = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    // Telefonnummer validieren
    const phoneRegex = /^\+?[1-9]\d{1,14}$/;
    if (!phoneRegex.test(phoneNumber.replace(/\s/g, ''))) {
      setError('Bitte geben Sie eine gültige Telefonnummer ein (z.B. +49123456789)');
      setLoading(false);
      return;
    }

    try {
      const response = await sendSmsVerification(user.id, phoneNumber);
      
      if (response.success) {
        setMessage('SMS wurde gesendet! Bitte geben Sie den 6-stelligen Code ein.');
        setStep('verify');
      } else {
        setError(response.error || 'Fehler beim Senden der SMS');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleVerifyCode = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!/^\d{6}$/.test(verificationCode)) {
      setError('Bitte geben Sie einen 6-stelligen Code ein');
      setLoading(false);
      return;
    }

    try {
      const response = await verifySmsCode(user.id, verificationCode);
      
      if (response.success) {
        setMessage('✅ SMS erfolgreich verifiziert!');
        setTimeout(() => {
          setStep('phone');
          setPhoneNumber('');
          setVerificationCode('');
          setMessage('');
        }, 3000);
      } else {
        setError(response.error || 'Ungültiger Bestätigungscode');
      }
    } catch (err) {
      setError('Netzwerkfehler: ' + err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleReset = () => {
    setStep('phone');
    setPhoneNumber('');
    setVerificationCode('');
    setMessage('');
    setError('');
  };

  return (
    <div style={{
      background: 'white',
      border: '1px solid #e2e8f0',
      borderRadius: '8px',
      padding: '20px',
      margin: '20px 0'
    }}>
      <h3 style={{ 
        margin: '0 0 20px 0',
        color: '#2d3748',
        fontSize: '1.2rem'
      }}>
        📱 SMS Test Funktion
      </h3>

      {message && (
        <div style={{
          backgroundColor: '#c6f6d5',
          color: '#276749',
          padding: '10px',
          borderRadius: '6px',
          marginBottom: '15px',
          border: '1px solid #9ae6b4'
        }}>
          {message}
        </div>
      )}

      {error && (
        <div style={{
          backgroundColor: '#fed7d7',
          color: '#c53030',
          padding: '10px',
          borderRadius: '6px',
          marginBottom: '15px',
          border: '1px solid #feb2b2'
        }}>
          {error}
        </div>
      )}

      {step === 'phone' ? (
        <form onSubmit={handleSendSms}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontWeight: '500',
              color: '#4a5568'
            }}>
              Telefonnummer für Test:
            </label>
            <input
              type="tel"
              value={phoneNumber}
              onChange={(e) => setPhoneNumber(e.target.value)}
              placeholder="+49123456789"
              required
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '14px'
              }}
            />
            <small style={{ color: '#718096', fontSize: '12px' }}>
              Format: +49123456789 (mit Ländervorwahl)
            </small>
          </div>

          <button
            type="submit"
            disabled={loading || !phoneNumber}
            style={{
              backgroundColor: loading ? '#a0aec0' : '#4a6de5',
              color: 'white',
              border: 'none',
              borderRadius: '6px',
              padding: '10px 20px',
              cursor: loading ? 'not-allowed' : 'pointer',
              fontSize: '14px',
              fontWeight: '500'
            }}
          >
            {loading ? 'Wird gesendet...' : 'SMS Test senden'}
          </button>
        </form>
      ) : (
        <form onSubmit={handleVerifyCode}>
          <div style={{ marginBottom: '15px' }}>
            <label style={{
              display: 'block',
              marginBottom: '5px',
              fontWeight: '500',
              color: '#4a5568'
            }}>
              6-stelliger Bestätigungscode:
            </label>
            <input
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value.replace(/\D/g, '').slice(0, 6))}
              placeholder="123456"
              maxLength="6"
              required
              style={{
                width: '200px',
                padding: '10px',
                border: '1px solid #e2e8f0',
                borderRadius: '6px',
                fontSize: '18px',
                textAlign: 'center',
                letterSpacing: '2px'
              }}
            />
            <div style={{ marginTop: '10px' }}>
              <small style={{ color: '#718096', fontSize: '12px' }}>
                SMS gesendet an: {phoneNumber}
              </small>
            </div>
          </div>

          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              type="submit"
              disabled={loading || verificationCode.length !== 6}
              style={{
                backgroundColor: loading ? '#a0aec0' : '#22c55e',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                padding: '10px 20px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontSize: '14px',
                fontWeight: '500'
              }}
            >
              {loading ? 'Prüfe...' : 'Code bestätigen'}
            </button>

            <button
              type="button"
              onClick={handleReset}
              style={{
                backgroundColor: '#f3f4f6',
                color: '#4b5563',
                border: '1px solid #d1d5db',
                borderRadius: '6px',
                padding: '10px 20px',
                cursor: 'pointer',
                fontSize: '14px'
              }}
            >
              Zurück
            </button>
          </div>
        </form>
      )}

      <div style={{
        marginTop: '20px',
        padding: '10px',
        backgroundColor: '#f7fafc',
        borderRadius: '6px',
        fontSize: '12px',
        color: '#4a5568'
      }}>
        <strong>Info:</strong> Dies ist eine Test-Funktion für Administratoren. 
        Codes sind 15 Minuten gültig und werden automatisch gelöscht.
      </div>
    </div>
  );
}

export default SmsTestPanel;